<template>
  <div class="commentlist-base">
    <template v-if="commentData">
      <p class="section_title u-tx-center u-mg-b-2">カスタマーレビュー</p>
      <div class="evaluate-ave">
        <span class="evaluate-star">
          <span :class="{full: pointAve > 0 }"></span>
          <span :class="{full: pointAve > 1 }"></span>
          <span :class="pointAve >= 2.5 ? (pointAve > 2.75 ? 'full' : 'half') : ''"></span>
        </span>
        <span class="num">{{ pointAve | pointAveRound }}</span>
      </div>
      <div class="commentlist">
        <section v-for="(item,index) in commentData.data" :key="index">
          <div class="comment-wrap">
            <div class="comment-head">
              <span class="evaluate-star">
                <span :class="{full: parseInt(item.evaluation) > 0 }"></span>
                <span :class="{full: parseInt(item.evaluation) > 1 }"></span>
                <span :class="{full: parseInt(item.evaluation) > 2 }"></span>
              </span>
              <span class="nickname">{{item.nickname}}</span>
              <span class="datetime">{{ item.created_at | datetime }}</span>
            </div>
            <div class="info-area">
              <div class="comment">{{item.comment_text}}</div>
            </div>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>


<script>
import { mapState, mapGetters } from 'vuex';
import * as type from '@/utvStore/store/mutation-types';

export default {
  name: "commentList",
  computed: {
    ...mapState({
      commentData: state => state.commentView.commentData,
      pointAve: state => state.commentView.pointAve
    })
  },
  props: {
    itemType: {
      type: String,
      default: null
    },
    itemsId: {
      type: String,
      default: null
    },
    digiId: {
      type: String,
      default: null
    },
    customId: {
      type: String,
      default: null
    }
  },
  mounted() {
    const params = {}
    switch (this.itemType) {
      default:
        params.items_id = this.itemsId
        params.display_flug = 1
        break;
    }
    this.$store.dispatch(type.GET_COMMENT_LIST, params);
  },
  filters: {
    datetime(value) {
      const dt = new Date(value)
      return `(${dt.getFullYear()}年${dt.getMonth() + 1}月${dt.getDate()}日)`
    },
    pointAveRound(value) {
      return value.toFixed(2)
    }

  }
}
</script>

<style scoped lang="scss">
@import '../../../sass/variables/colors.scss';
.commentlist-base{
  width: 100%;
  margin-top: 40px;
  padding-top: 16px;
  border-top: 1px solid $gray-9;
  margin-bottom: 40px;
  .evaluate-ave {
    width: 100%;
    text-align: center;
    margin-bottom: 16px;
    span {
      display: inline-block;
      vertical-align: middle;
      &.evaluate-star {
        span {
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url('/static/img/icons/icon_evaluate_star_blank.svg') no-repeat center center;
          background-size: cover;
          margin-bottom: 4px;
          &.full {
            background: url('/static/img/icons/icon_evaluate_star.svg') no-repeat center center;
            background-size: cover;
          }
          &.half {
            background: url('/static/img/icons/icon_evaluate_star.svg') no-repeat center center;
            background-size: cover;
          }
        }
      }
      &.num {
        color: #ff7700;
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
  .commentlist {
    section {
      width: 100%;
      border: 1px solid $gray-8;
      border-radius: 4px;
      margin-bottom: 12px;
      padding: 8px 12px 12px;
      .comment-head {
        width: 100%;
        padding: 0 4px 8px;
        border-bottom: 1px solid $gray-10;
        font-size: 14px;
        font-weight: bold;
        span{
          vertical-align: middle;
        }
        .evaluate-star {
          display: inline-block;
          margin-right: 8px;
          span {
            display: inline-block;
            width: 16px;
            height: 16px;
            background: url('/static/img/icons/icon_evaluate_star_blank.svg') no-repeat center center;
            background-size: cover;
            margin-bottom: 4px;
            &.full {
              background: url('/static/img/icons/icon_evaluate_star.svg') no-repeat center center;
              background-size: cover;
            }
          }
        }
        .datetime {
          color: $gray-3;
          font-size: 11px;
          margin-left: 4px;
        }
      }
      .info-area {
        padding-top: 8px;
        .comment {
          line-height: 1.5;
          font-size: 12px;
          color: $gray-7;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/CommentList.vue